import '../scss/app.scss';

import $ from 'jquery';
window.jQuery = window.$ = global.jQuery = global.$ = $;

import { Fancybox } from '@fancyapps/ui';
import 'select2';

import 'jquery-mask-plugin';

import './blocks/header_nav.js';
import './blocks/sliders.js';

import './blocks/aside.js';

import './blocks/search.js';

import './blocks/mixitup.js';

import './blocks/float.js';
import './blocks/to-top.js';
import './blocks/spoiler';
import './blocks/tag-list';

import './blocks/form.js';

import './blocks/how-we-work.js';
import './blocks/steps.js';
import './blocks/faq.js';
import './blocks/equipment.js';
import './blocks/vacancy.js';
import './blocks/account.js';
import './blocks/order.js';
import './blocks/portfolio-categories.js';
import './blocks/price-modal.js';
import './blocks/pdopage.js';

global.width_sm = 576;
global.width_md = 768;
global.width_lg = 992;
global.width_xl = 1200;
global.width_xxl = 1400;

$(document).ready(function() {
  $('select').select2({
    theme: 'pmg',
  });
});

global.scrollToId = (elementId) => {
  const viewportOffset = document.getElementById(elementId).getBoundingClientRect();
  const top = viewportOffset.top + (window.scrollY ? window.scrollY : window.pageYOffset);

  $('html, body').animate({ scrollTop: (top - 100) }, 600);
};
